// extracted by mini-css-extract-plugin
module.exports = {"add-box-page-title":"AddBoxForm_add-box-page-title__Ap6kB"};